import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const IMAGES = [
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_electro-precision-gc/artifacts/hazbwc0a_image.png",
    cat: "instalaciones",
    title: "Canalización en obra nueva",
    place: "Gran Canaria",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_electro-precision-gc/artifacts/wesssrrl_image.png",
    cat: "comunidades",
    title: "Cuadro comunitario ordenado",
    place: "Gran Canaria",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_electro-precision-gc/artifacts/ce74b448_image.png",
    cat: "recarga",
    title: "Poste de recarga Policharger",
    place: "Gran Canaria",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_electro-precision-gc/artifacts/clu8xuho_image.png",
    cat: "recarga",
    title: "Wallbox Circutor en garaje",
    place: "Gran Canaria",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_electro-precision-gc/artifacts/2jhklgl7_image.png",
    cat: "instalaciones",
    title: "Peine de tierras y magnetotérmicos",
    place: "Gran Canaria",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_electro-precision-gc/artifacts/7orvbod2_image.png",
    cat: "instalaciones",
    title: "Cuadro general con acometida ordenada",
    place: "Gran Canaria",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_electro-precision-gc/artifacts/t6tifx9h_image.png",
    cat: "comunidades",
    title: "Cuadro Schneider en armario vertical",
    place: "Gran Canaria",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_electro-precision-gc/artifacts/xfooormt_image.png",
    cat: "instalaciones",
    title: "Trazado eléctrico en nave industrial",
    place: "Gran Canaria",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_electro-precision-gc/artifacts/uk285hxj_image.png",
    cat: "averias",
    title: "Cajas de derivación en rehabilitación",
    place: "Gran Canaria",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_electro-precision-gc/artifacts/e8snqx4w_image.png",
    cat: "mantenimiento",
    title: "Mantenimiento fotovoltaica en cubierta",
    place: "Gran Canaria",
  },
];

const FILTERS = [
  { id: "all", label: "Todos" },
  { id: "instalaciones", label: "Instalaciones" },
  { id: "comunidades", label: "Comunidades" },
  { id: "mantenimiento", label: "Mantenimiento" },
  { id: "recarga", label: "Recarga VE" },
  { id: "averias", label: "Averías" },
];

export default function Gallery() {
  const [filter, setFilter] = React.useState("all");
  const [lightbox, setLightbox] = React.useState(null);
  const items = IMAGES.filter((i) => filter === "all" || i.cat === filter);

  return (
    <section id="galeria" className="relative py-24 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10">
          <div>
            <span className="section-label mb-4">06 · Galería</span>
            <h2 className="font-display text-4xl sm:text-5xl text-white mt-4 leading-[0.95]">
              Trabajos <span className="text-[#E57C23]">recientes.</span>
            </h2>
          </div>
          <div className="flex flex-wrap gap-2" data-testid="gallery-filters">
            {FILTERS.map((f) => (
              <button
                key={f.id}
                onClick={() => setFilter(f.id)}
                data-testid={`gallery-filter-${f.id}`}
                className={`px-4 py-2 rounded-full text-sm border transition-all ${
                  filter === f.id
                    ? "border-[#E57C23] bg-[#E57C23]/10 text-white"
                    : "border-white/10 text-white/60 hover:text-white hover:border-white/30"
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((img, i) => (
            <motion.button
              type="button"
              key={img.src}
              onClick={() => setLightbox(img)}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="group relative aspect-[4/3] rounded-2xl overflow-hidden border border-white/8 text-left"
            >
              <img
                src={img.src}
                alt={img.title}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-[900ms] group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0D14] via-[#0A0D14]/40 to-transparent" />
              <div className="absolute inset-0 bg-[#00E5FF]/0 group-hover:bg-[#00E5FF]/5 transition-colors" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="font-mono text-[10px] text-[#00E5FF] tracking-widest uppercase">
                  {img.place}
                </div>
                <div className="font-display text-lg text-white mt-1">{img.title}</div>
              </div>
            </motion.button>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {lightbox && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setLightbox(null)}
            className="fixed inset-0 z-[100] bg-[#0A0D14]/95 backdrop-blur-md flex items-center justify-center p-6"
            data-testid="gallery-lightbox"
          >
            <motion.div
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
              className="relative max-w-5xl w-full max-h-[85vh] rounded-3xl overflow-hidden border border-white/10 bg-[#121620]"
            >
              <img src={lightbox.src} alt={lightbox.title} className="w-full h-full object-contain max-h-[80vh]" />
              <div className="absolute top-3 right-3">
                <button
                  onClick={() => setLightbox(null)}
                  className="h-10 w-10 rounded-full bg-[#0A0D14]/70 border border-white/10 text-white flex items-center justify-center hover:bg-[#E57C23] transition-colors"
                  aria-label="Cerrar"
                  data-testid="lightbox-close"
                >
                  <X size={18} />
                </button>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-[#0A0D14] to-transparent">
                <div className="font-mono text-[11px] text-[#00E5FF]">{lightbox.place}</div>
                <div className="font-display text-2xl text-white">{lightbox.title}</div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
